import { render, staticRenderFns } from "./MemberFreeze.vue?vue&type=template&id=78c9d34c&"
import script from "./MemberFreeze.vue?vue&type=script&lang=ts&"
export * from "./MemberFreeze.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports